export default function equals(nodes1, nodes2) {
  if (nodes1.count() !== nodes2.count()) return false

  for (let i = 0, l = nodes1.count(); i < l; i = i + 1) {
    const node1 = nodes1.get(i)
    const node2 = nodes2.get(i)

    if (node1.get('id') !== node2.get('id')) return false
    if (!equals(node1.get('children'), node2.get('children'))) return false
  }

  return true
}
